export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/a252db15ddae90a3a19c6d2e1380cf3f.jpg";